import * as React from "react";
import { Container, Row, Col } from 'reactstrap';
import { Icon, Upload, Button, Input, Carousel, Checkbox, Modal } from 'antd';
import { FileParam, FileType } from "../../APIModels/FileParam";
import SERVER_URL from '../../Global'
import { blobToSRC, downloadFileBlob } from "../../util/UtilFunction";
import FileService from "../../Services/fileService";
import Spin from "antd/lib/spin";
import ArticleService from "../../Services/articleService";

export class HandleArticleFileRender extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            user: this.props.user,
            article: this.props.article,
            countPage: this.props.article.countPage,
            fileParam: new FileParam(),
            fileParamAudio: new FileParam(),
            imgList: [],
            audioList: [],
            img: null,
            audio: null,
            pdfPage: null,
            imgSaved: false,
            audioSaved: true,
            images: [],
            audios: [],
            pages: [],
            uploadedPages: [],
            missingPages: [],
            loaderImg: false,
            loaderAudio: false,
            loaderPages: false,
            errorMessagge: '',
            errorMessageAudio: '',
            errorMessaggePage: '',
            modalOpen: false,
            modalTitle: '',
            modalId: '',
            modalType: ''
        }

        this.fileService = new FileService(this.state.user);
        this.articleService = new ArticleService(this.state.user);

        this.handleupload = this.handleupload.bind(this);
        this.handleuploadAudio = this.handleuploadAudio.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.uploadImgArticle = this.uploadImgArticle.bind(this);
        this.uploadAudioArticle = this.uploadAudioArticle.bind(this);
        this.handleuploadPagePDF = this.handleuploadPagePDF.bind(this);
        this.upload = this.upload.bind(this);
        this.removeUpload = this.removeUpload.bind(this);
        this.getFile = this.getFile.bind(this);
        this.fetchArticleById = this.fetchArticleById.bind(this);
        this.visualizeArticle = this.visualizeArticle.bind(this);
    }

    componentDidMount() {
        if (this.state.article.files) {
            this.getFile()
        }
    }


    fetchArticleById(id) {
        this.props.loader(true)
        this.articleService.getArticle(id)
            .then((response) => {
                this.setState({ article: response.data.data }, (() => this.getFile()))
                this.props.loader(false)
            }).catch((err) => {
                console.log(err);
                this.props.loader(false)
            })
    }

    getFile = async () => {
        if (!this.state.article.files) {
            return
        }
        let imgs = this.state.article.files.filter(f => f.type == FileType.Image);
        let audios = this.state.article.files.filter(f => f.type == FileType.Audio);
        let pages = this.state.article.files.filter(f => f.type == FileType.Page);

        this.setState({ loaderPages: true})

        if (imgs.length > 0) {
            this.setState({ loaderImg: true, imgSaved: true })
            const imgsPromise = imgs.map(img => {

                return new Promise((resolve) => {
                    this.fileService.downloadFile(img.id)
                        .then(resp => {
                            var reader = blobToSRC(resp.data)
                            reader.onload = async () => {
                                let base64 = reader.result
                                img.src = base64
                                resolve(img);
                            };
                        })
                })
            })

            const imgsWithSrc = await Promise.all(imgsPromise);
            this.setState({ loaderImg: false, images: imgsWithSrc.reverse() })
        }

        if (audios.length > 0) {
            this.setState({ loaderAudio: true})
               const audiosPromise = audios.map(audio => {
                    return new Promise((resolve) => {

                    this.fileService.downloadFile(audio.id)
                        .then(resp => {
                            const blob = new Blob([resp.data], { type: 'audio/mpeg' });
                            const url = window.URL.createObjectURL(blob);
                            audio.src = url
                            resolve(audio);
                        })
                })
            })

            const audiosWithSrc = await Promise.all(audiosPromise);
            this.setState({ loaderAudio: false, audios: audiosWithSrc.reverse() })
        }

        const totalPages = Array.from({ length: this.state.article.pageTo - this.state.article.pageFrom + 1 },
            (_, i) => this.state.article.pageFrom + i);
        const uploadedPages = pages.map(page => page.pageNumber);
        const missingPages = totalPages.filter(num => !uploadedPages.includes(num));

        this.setState({
            loaderPages: false,
            pages: pages,
            uploadedPages: uploadedPages,
            missingPages: missingPages
        });
    }


    //upload immagini
    handleupload(e) {
        let file = e.file;
        let fileList = e.fileList;
        fileList = fileList.slice(-1);
        this.setState({ img: file, imgList: fileList, imgSaved: false, errorMessagge: '' })
    }

    //upload audio
    handleuploadAudio(e) {
        let file = e.file;
        let fileList = e.fileList;
        fileList = fileList.slice(-1);
        this.setState({ audio: file, audioList: fileList, audioSaved: false, errorMessaggeAudio: '' })
    }

    //upload pdf
    handleuploadPagePDF(e, pageNum) {
        let file = e.file;
        this.setState({ pdfPage: file, pageNumber: pageNum }, (() => this.uploadPageArticle(pageNum)))
    }

    //modifica descrizione
    handleInputChange({ target }) {
        const value = target.value;
        const name = target.name;
        const param = target.attributes.param.value
        const saved = param == "fileParam" ? "imgSaved" : "audioSaved";
        this.setState(prevState => ({
            [param]: {
                ...prevState.file,
                [name]: value
            },
            [saved]: false
        }))
    }

    handleCheckboxChange({ target }) {
        const value = target.checked;
        const param = this.state.fileParam;
        param.isMainImage = value;
        this.setState({ fileParam: param })
    }

    //preparo il formData per il fetch in upload() JPG / PNG
    uploadImgArticle() {

        let img = this.state.img;
        var formData = new FormData();
        let param = this.state.fileParam;

        param.articleId = this.state.article.id
        param.type = FileType.Image;
        param.fileName = img.name;

        formData.append("file", img)
        formData.append("param", JSON.stringify(param))

        const correctType = img.type === 'image/jpeg' || img.type === 'image/png';
        if (!correctType) {
            this.setState({ errorMessagge: 'file not allowed' }, (() => this.removeUpload("img")))
            return;
        }

        this.upload(formData, "img")
    }

    //preparo il formData per il fetch in upload() MP3
    uploadAudioArticle() {

        let audio = this.state.audio;
        var formData = new FormData();
        let param = this.state.fileParamAudio;

        param.articleId = this.state.article.id
        param.type = FileType.Audio;
        param.fileName = audio.name;

        formData.append("file", audio)
        formData.append("param", JSON.stringify(param))

        const correctType = audio.type === 'audio/mpeg';
        if (!correctType) {
            this.setState({ errorMessaggeAudio: 'file not allowed' }, (() => this.removeUpload("audio")))
            return;
        }

        this.upload(formData, "audio")
    }

    //preparo il formData per il fetch in upload() PDF
    uploadPageArticle(pageNum) {
        let page = this.state.pdfPage;
        var formData = new FormData();
        let param = new FileParam();

        param.articleId = this.state.article.id
        param.type = FileType.Page;
        param.fileName = page.name;
        param.pageNumber = pageNum;

        formData.append("file", page)
        formData.append("param", JSON.stringify(param))

        const correctType = page.type === 'application/pdf';
        if (!correctType) {
            this.setState({ errorMessaggePage: 'file not allowed' }, (() => this.removeUpload("page")))
            return;
        }

        this.upload(formData, "page")
    }

    //chiamata fetch con form Data per il file e i relativi parametri
    upload(formData, nameofType) {
        fetch(SERVER_URL + 'api/File/Upload', {
            method: "POST",
            headers: {
                Accept: "application/json",
                contentType: 'multipart/form-data',
                authorization: "Bearer " + this.state.user
            },
            body: formData
        }).then(resp => {
            if (resp.ok) {
                if (nameofType == "img")
                    this.setState({ imgSaved: true, img: null, imgList: [], fileParam: new FileParam() }, (() => {
                        this.fetchArticleById(this.state.article.id)
                        this.getFile()
                    }))
                else if (nameofType == "audio")
                    this.setState({ audioSaved: true, audio: null, audioList: [], fileParamAudio: new FileParam() }, (() => {
                        this.fetchArticleById(this.state.article.id)
                        this.getFile()
                    }))
                else if (nameofType == "page")
                    this.setState({ pdfPage: null }, (() => {
                        this.fetchArticleById(this.state.article.id)
                        this.getFile()
                    }))
            }
        })
    }

    //rimozione file dalla lista
    removeUpload(t) {
        if(t == "img")
            this.setState({ img: null, imgList: [] })
        else if (t == "audio")
            this.setState({ audio: null, audioList: [] })
    }

    //delete file, prende id e nome del file da cancellare, in modo da poi
    //aggiornare lo state
    deleteFile(id, file) {
        let saved = '';
        if (file == "images")
            saved = "imgSaved"
        if (file == "audios")
            saved = "audioSaved"
        this.props.loader(true)
        this.fileService.deleteFile(id)
            .then(resp => {
                this.props.loader(false)
                this.setState(
                {
                    [file]: [],
                    [saved]: false,
                    modalOpen: false,
                    modalTitle: '',
                    modalId: null
                },
                (() => this.fetchArticleById(this.state.article.id)))
            })
            .catch(err => {
                this.props.loader(false)
                console.log(err)
            })
    }

    //download file
    downloadFile(id, name, type) {
        this.fileService.downloadFile(id)
            .then(resp => {
                downloadFileBlob(resp.data, name, type)
            })
    }

    //go to detail
    visualizeArticle() {
        return window.open("/archive/article/detail?id=" + this.state.article.id, '_self');
    }

    //add another article
    addAnotherArticle(){
        return  window.open('/archive/articles/create?editionId=' + this.state.article.editionId, '_self');
    }

    backToArticles(){
        return  window.open('/archive/articles/', '_self');
    }

    setModal(value, title, id, type) {
        this.setState({ modalOpen: value, modalTitle: title, modalId: id, modalType: type })
    }

    handleCancel() {
        this.setState({ modalOpen: false, modalTitle: '', modalId: null })
    }

    render() {
        //props Upload
        const props = {
            beforeUpload: (file) => {
                return false; //serve per rimuovere la action
            }
        };

        const { pageFrom, pageTo } = this.state.article;
        const { uploadedPages } = this.state;

        // Generate total pages from pageFrom to pageTo
        const totalPages = Array.from({ length: +pageTo - +pageFrom + 1 }, (_, i) => +pageFrom + i);

        const pageUpload = totalPages
            .filter(pageNum => !uploadedPages.includes(pageNum)) // Filter out uploaded pages
            .map((pageNum) => (
                <Col key={pageNum} sm="3" className="px-3 my-3">
                    <Upload
                        accept=".pdf"
                        onChange={(e) => this.handleuploadPagePDF(e, pageNum)}
                        fileList={[]}
                        {...props}
                    >
                        <Button>
                            <Icon type="upload" /> Upload for Page {pageNum}
                        </Button>
                    </Upload>
                    {this.state.errorMessaggePage && (
                        <p style={{ color: "indianred", margin: "10px 0 0 0" }}>
                            {this.state.errorMessaggePage}
                        </p>
                    )}
                </Col>
            ));

        let modal =
            <Modal title="Delete" visible={this.state.modalOpen} onOk={() => this.deleteFile(this.state.modalId, this.state.modalType)} onCancel={() => this.handleCancel()}>
                <p>Delete {this.state.modalType} of article: {this.state.modalTitle}?</p>
            </Modal>

        return (
            <Row style={{ width: '100%' }}>
                <Col style={{ minHeight: '50vh' }} sm='12'>
                    <div className="wizardFields wizardContacts" style={{ minHeight: '50vh' }}>
                        <div className="wizardBackground createCat" style={{ height: 'inherit' }}>
                            <div className="modifyHrBox" style={{ width: '100%' }}>
                                {/*Images*/}
                                <div className={"modifyHr" + this.state.imgSaved} style={{ width: '100%' }}>
                                    <Row className="p-3">
                                        <Col sm="12" className="mb-4">
                                            <h3 style={{ width: 'auto', fontSize: 22 }}>Article images:</h3>
                                        </Col>
                                        <Col sm="2">
                                            <Upload accept=".png, .jpg" onChange={this.handleupload} fileList={this.state.imgList} {...props}>
                                                <Button > <Icon type="upload" /> Upload</Button>
                                            </Upload>
                                            {this.state.errorMessagge && <p style={{ color: "indianred", margin: "10px 0 0 0" }}>{this.state.errorMessagge}</p>}
                                        </Col>
                                        <Col sm="4">
                                            <Input type="text" param="fileParam" name="description" placeholder="Caption" value={this.state.fileParam.description} onChange={this.handleInputChange} />
                                        </Col>
                                        <Col sm="2">
                                            <Checkbox param="fileParam" name="isMainImage" checked={this.state.fileParam.isMainImage} onChange={this.handleCheckboxChange}>Main Image</Checkbox>
                                        </Col>
                                        <Col sm="4">
                                            <Button disabled={this.state.img == null}
                                                    className={this.state.img != null ? 'fmk_button_to_save': ''}
                                                    onClick={this.uploadImgArticle}>
                                                    <span>Save</span>
                                            </Button>
                                        </Col>
                                    </Row>
                                    {this.state.images &&
                                        !this.state.loaderImg ? (
                                        <Carousel className="p-4" slidesToShow={3} infinite={false} arrows={true} draggable={true}>
                                            {this.state.images.map(img => {
                                                return (
                                                    <div key={img.id} className="position-relative">
                                                        <div className="d-flex justify-content-center position-relative">
                                                            <img className="articleImg" src={img.src} />
                                                            <div className="overlayImg">
                                                                <Icon style={{ fontSize: 30, color: "#fff" }} onClick={() => this.setModal(true, this.state.article.title, img.id, "images")} type="delete" />
                                                            </div>
                                                        </div>
                                                        {img.isMainImage && <Icon type="star" theme="filled" className="isMainImage" />}
                                                        <p className="p-2" style={{ marginLeft: "9%" }}>{img.description}</p>
                                                    </div>
                                                )
                                            })}
                                        </Carousel>
                                    ) : (<div className="d-flex justify-content-center p-4"> <Spin /></div>)
                                    }
                                </div>
                            </div>
                            {/*Audio*/}
                            <div className="modifyHrBox" style={{ width: '100%' }}>
                                <div className={"modifyHr" + this.state.audioSaved} style={{ width: '100%' }}>
                                    <Row className="p-3">
                                        <Col sm="12" className="mb-4">
                                            <h3 style={{ width: 'auto', fontSize: 22 }}>Article audio:</h3>
                                        </Col>
                                        <Col sm="2">
                                            <Upload accept=".mp3" onChange={this.handleuploadAudio} fileList={this.state.audioList} {...props}>
                                                <Button > <Icon type="upload" /> Upload</Button>
                                            </Upload>
                                            {this.state.errorMessaggeAudio && <p style={{ color: "indianred", margin: "10px 0 0 0" }}>{this.state.errorMessaggeAudio}</p>}
                                        </Col>
                                        <Col sm="4">
                                            <Input type="text" param="fileParamAudio" name="description" placeholder="Caption" value={this.state.fileParamAudio.description} onChange={this.handleInputChange} />
                                        </Col>
                                        <Col sm="6">
                                            <Button disabled={this.state.audio == null} onClick={this.uploadAudioArticle}>Save</Button>
                                        </Col>
                                    </Row>
                                    {this.state.audios &&
                                        !this.state.loaderAudio ? (

                                        this.state.audios.map(audio => {
                                            return (
                                                <Row key={audio.id} className="my-4 align-items-center">
                                                    <Col sm="1" className="text-center">
                                                        <Icon style={{ fontSize: 20 }} onClick={() => this.setModal(true, this.state.article.title, audio.id, "audios")} type="delete" />
                                                    </Col>
                                                    <Col sm="4">
                                                        <audio className="w-100" controls>
                                                            <source src={audio.src} />
                                                        </audio>
                                                    </Col>
                                                    <Col sm="7">
                                                        <p>
                                                            {audio.description}
                                                        </p>
                                                    </Col>
                                                </Row>
                                            )
                                        })

                                        ): ( <div className = "d-flex justify-content-center p-4"> <Spin /></div>)
                                    }
                                </div>
                            </div>
                            {/*PDF Pagine*/}
                            <div className="modifyHrBox" style={{ width: '100%' }}>
                                <div className={"modifyHr" + (this.state.pages.length === this.state.article.countPage)} style={{ width: '100%' }}>
                                    <h3 style={{ width: 'auto', fontSize: 22 }}>Article pages:</h3>
                                    {!this.state.loaderPages ? (
                                        <Row className="p-3">
                                            {/* Render already uploaded files */}
                                            {this.state.pages &&
                                                [...this.state.pages]
                                                    .sort((a, b) => a.pageNumber - b.pageNumber) // Sort by pageNumber
                                                    .map((page) => (
                                                        <Col key={page.id} sm="3" className="px-3 my-2">
                                                            <p><strong>Pag {page.pageNumber}:</strong></p>
                                                            {page.pageNumber < pageFrom || page.pageNumber > pageTo ? (
                                                                <p style={{ color: "red" }}>Page number out of range</p>
                                                            ) : null}
                                                            <p>{page.fileName}</p>
                                                            <Button
                                                                className="mr-4"
                                                                onClick={() => this.downloadFile(page.id, page.fileName, "application/pdf")}
                                                            >
                                                                Download
                                                            </Button>
                                                            <Button
                                                                onClick={() => this.setModal(true, this.state.article.title, page.id, "pdfComplete")}
                                                            >
                                                                Delete
                                                            </Button>
                                                        </Col>
                                                    ))}

                                            {pageUpload}
                                        </Row>
                                    ) : (
                                        <div className="d-flex justify-content-center p-4">
                                            <Spin />
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="d-flex justify-content-center position-relative" style={{ top: 10 }}>
                                <Button className="saveButtonHrWizard" onClick={() => this.visualizeArticle() } icon="eye" >View</Button>
                                <Button className="saveButtonHrWizard ml-3" onClick={() => this.addAnotherArticle() } icon="file-add" >Add another article</Button>
                            </div>
                        </div>
                    </div>
                </Col>
                {modal}
            </Row>
        )
    }
}





// WEBPACK FOOTER //
// ./src/FileMaker/Articles/HandleArticleFileRender.js